module.exports = __webpack_public_path__ + "img/01.8b706c1c.png";